<template>
  <div class="editor">
    <transition-group name="editor-contents">
      <konva-viewer v-if="currentStep == 0" @selectSector="componentChange"/>
      <konva-seat-viewer v-if="currentStep == 1" :sectorRef="currentSectorRef"/>
    </transition-group>
  </div>
</template>

<script>
import KonvaViewer from '@/components/global/konva/KonvaViewer';
import KonvaSeatViewer from '@/components/global/konva/KonvaSeatViewer';

export default {
  name: 'SystemSettings',
  components: {
    KonvaViewer,
    KonvaSeatViewer,
  },
  data() {
    return {
      currentStep: 0,
      currentSectorRef: undefined,
    }
  },
  methods: {
    componentChange(ref) {
      this.currentSectorRef = ref;
      this.currentStep = -1
      setTimeout(() => {
        this.currentStep = 1;
      }, 500);
    }
  }
}
</script>

<style lang="scss" scoped>
.editor {
  height: calc(100% - 60px) !important;
  overflow-x: hidden;
}
.editor-contents-enter-active,
.editor-contents-leave-active {
  transition: all 0.5s ease;
  overflow: hidden;
}
.editor-contents-enter-from,
.editor-contents-leave-to {
  position: absolute;
  overflow: hidden;
  opacity: 0;
  transform: translateX(120px);
}
</style>